<template>
	<div class="hero-section to-indigo-900 via-blue-900 from-slate-900 bg-gradient-to-br">
		<!-- 背景纹理 -->
		<!-- <div class="hero-bg-pattern"></div> -->

		<div class="hero-container">
			<div class="hero-content">
				<!-- 标签 -->
				<div class="hero-badge">
					<i class="el-icon-star-on"></i>
					<span>特种设备行业一站式合规服务平台</span>
				</div>

				<!-- 主标题 -->
				<h1 class="hero-title">
					正版图书 · AI服务 · 标准查询
					<br />
					<span class="hero-title-gradient">让合规更简单</span>
				</h1>

				<!-- 描述 -->
				<p class="hero-desc">依托特种设备行业正版图书资源，构建AI法规问答与层级化标准知识图谱， 为企业提供从图书采购到合规服务的全流程解决方案</p>

				<!-- CTA 按钮 -->
				<div class="hero-actions">
					<el-button class="hero-btn-primary" :class="{ 'tab-active': activeTab === 'search' }" round size="medium" @click="switchTab('search')"> <i class="el-icon-reading"></i> 标准查询 </el-button>
					<el-button class="hero-btn-secondary" :class="{ 'tab-active': activeTab === 'ai' }" round size="medium" @click="switchTab('ai')"> <i class="iconfont icon-aliwangwang-o" style="font-size: 17px;"></i> 体验AI问答 </el-button>
				</div>

				<!-- 搜索栏 - 标准查询 tab -->
				<div class="hero-search" v-if="activeTab === 'search'">
					<div class="hero-search-wrap">
						<!-- <i class="el-icon-search hero-search-icon"></i> -->
						<el-autocomplete
							v-model="searchQuery"
							class="hero-search-input"
							popper-class="hero-search-popper"
							placeholder="搜索图书、标准、法规..."
							:fetch-suggestions="querySearch"
							:trigger-on-focus="false"
							clearable
							@keyup.enter.native="handleSearch"
							@select="handleSelect"
						>
							<template slot-scope="{ item }">
								<div class="hero-suggest-item">
									<span class="hero-suggest-code" v-if="item.standardCode">{{ item.standardCode }}</span>
									<span class="hero-suggest-name">{{ item.standardName }}</span>
								</div>
							</template>
						</el-autocomplete>
						<button class="hero-search-btn" @click="handleSearch"><i class="el-icon-search"></i>搜索</button>
					</div>
				</div>

				<!-- AI 提问 - 体验AI问答 tab -->
				<div class="hero-ai-box" v-if="activeTab === 'ai'">
					<textarea v-model="aiQuestion" class="hero-ai-input" placeholder="请输入您想咨询的特种设备相关问题..." rows="3" @keyup.enter.exact="handleAIQuestion"></textarea>
					<button class="hero-ai-btn" @click="handleAIQuestion"><i class="el-icon-s-promotion"></i> 发送提问</button>
				</div>
			</div>
		</div>

		<!-- 波浪装饰 -->
		<div data-inspector-line="120" data-inspector-column="8" data-inspector-relative-path="src\\app\\page.tsx" class="absolute">
			<svg data-inspector-line="121" data-inspector-column="10" data-inspector-relative-path="src\\app\\page.tsx" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" style="">
				<path
					data-inspector-line="122"
					data-inspector-column="12"
					data-inspector-relative-path="src\\app\\page.tsx"
					d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z"
					fill="#f8fafc"
				></path>
			</svg>
		</div>
		<!-- <div class="hero-wave">
			<svg data-inspector-line="121" data-inspector-column="10" data-inspector-relative-path="src\\app\\page.tsx" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" style="">
				<path
					data-inspector-line="122"
					data-inspector-column="12"
					data-inspector-relative-path="src\\app\\page.tsx"
					d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z"
					fill="#f8fafc"
				></path>
			</svg>
		</div> -->
	</div>
</template>

<script>
	import { getSearchList } from '@/api/standards/search';

	export default {
		data() {
			return {
				searchQuery: '',
				aiQuestion: '',
				activeTab: 'search'
			};
		},
		methods: {
			switchTab(tab) {
				this.activeTab = tab;
			},
			// 联想搜索：根据关键词返回标准/法规建议列表
			async querySearch(queryString, cb) {
				const q = (queryString || '').trim();
				if (!q) {
					cb([]);
					return;
				}
				try {
					const res = await getSearchList({
						searchValue: q,
						industryId: [1]
					});
					if (res && res.code == 200 && Array.isArray(res.data)) {
						const results = res.data.map(item => {
							const { standardName, standardCode } = item;
							const label = `${standardCode ? standardCode + ' ' : ''}${standardName || ''}`.trim();
							return { value: label, standardCode, standardName };
						});
						cb(results);
					} else {
						cb([]);
					}
				} catch (e) {
					cb([]);
				}
			},
			handleSelect(item) {
				this.searchQuery = item && item.value ? item.value : this.searchQuery;
				this.handleSearch();
			},
			handleSearch() {
				if (this.searchQuery && this.searchQuery.trim()) {
					this.$router.push({ path: '/StandardsList', query: { keyword: this.searchQuery.trim() } });
				}
			},
			handleAIQuestion() {
				const q = this.aiQuestion.trim();
				if (!q) return;
				this.$router.push({ path: '/ai', query: { question: q } });
			}
		}
	};
</script>

<style lang="less" scoped>
	// ========== Hero Section - 1:1 还原 lz_project ==========
	.hero-section {
		position: relative;
		overflow: hidden;
		color: #ffffff;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgb(195, 200, 224);

		// 直接写死渐变，与 lz_project from-slate-900 via-blue-900 to-indigo-900 完全一致
		background-image: linear-gradient(to bottom right, #0f172a 0%, #1e3a8a 50%, #312e81 100%);

		// Tailwind 渐变色变量（保留备用）
		--color-slate-900: #0f172a;
		--color-blue-900: #1e3a8a; // Tailwind blue-900 正确值
		--color-indigo-900: #312e81;
		--tw-gradient-from-position: 0%;
		--tw-gradient-via-position: 50%;
		--tw-gradient-to-position: 100%;
	}

	// Tailwind 渐变工具类
	.bg-gradient-to-br {
		--tw-gradient-position: to bottom right in oklab;
		background-image: linear-gradient(var(--tw-gradient-stops));
	}

	.from-slate-900 {
		--tw-gradient-from: var(--color-slate-900);
		--tw-gradient-stops: var(--tw-gradient-via-stops);
	}

	.via-blue-900 {
		--tw-gradient-via: var(--color-blue-900);
		--tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position),
			var(--tw-gradient-to) var(--tw-gradient-to-position);
		--tw-gradient-stops: var(--tw-gradient-via-stops);
	}

	.to-indigo-900 {
		--tw-gradient-to: var(--color-indigo-900);
		--tw-gradient-stops: var(--tw-gradient-via-stops);
	}

	// 背景纹理 - 匹配 lz_project base64 等效
	.hero-bg-pattern {
		position: absolute;
		inset: 0;
		background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v2H4v-2h32zm0-4v2H4v-4h32zm0-12vH4v-14h32z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
		opacity: 0.5;
	}

	// 容器 - 匹配 lz_project max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-28
	.hero-container {
		position: relative;
		width: 100%;
		max-width: 1280px;
		margin: 0 auto;
		padding: 80px 32px;
		box-sizing: border-box;
		margin-bottom: 54px;
	}

	.hero-content {
		text-align: center;
	}

	// 顶部标签 - 匹配 lz_project inline-flex bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm mb-6
	.hero-badge {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(4px);
		padding: 8px 16px;
		border-radius: 9999px;
		font-size: 14px;
		color: #e2e8f0;
		margin-bottom: 24px;

		i {
			color: #fbbf24;
			font-size: 16px;
		}
	}

	// 主标题 - 匹配 lz_project text-4xl md:text-6xl font-bold mb-6 leading-tight
	.hero-title {
		font-size: 60px; // text-6xl
		font-weight: 800;
		line-height: 1.25;
		margin: 0 0 24px;
		letter-spacing: -0.5px;
	}

	// 标题渐变 - 匹配 lz_project bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text
	.hero-title-gradient {
		background: linear-gradient(to right, #60a5fa, #22d3ee);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
	}

	// 描述 - 匹配 lz_project text-xl text-slate-300 max-w-3xl mx-auto mb-10
	.hero-desc {
		font-size: 20px; // text-xl
		color: #cbd5e1; // text-slate-300
		line-height: 1.7;
		max-width: 768px; // max-w-3xl
		margin: 0 auto 40px; // mb-10
	}

	// 搜索栏 - 匹配 lz_project max-w-2xl mx-auto mb-10 relative
	.hero-search {
		max-width: 672px; // max-w-2xl
		margin: 40px auto 0; // mb-10
	}

	.hero-search-wrap {
		position: relative;
		display: flex;
		align-items: center;
	}

	.hero-search-icon {
		position: absolute;
		left: 20px;
		font-size: 18px;
		color: #94a3b8;
		z-index: 1;
		pointer-events: none;
	}

	// 搜索输入框 - 匹配 lz_project px-6 py-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20
	.hero-search-input {
		width: 100%;
		display: block;

		/deep/ .el-input__inner {
			width: 100%;
			height: auto;
			padding: 19px 128px 19px 20px; // 左留出图标位置，右留出按钮+清除图标位置
			border-radius: 16px; // rounded-2xl
			background: rgba(255, 255, 255, 0.1);
			backdrop-filter: blur(4px);
			border: 1px solid rgba(255, 255, 255, 0.2);
			color: #ffffff;
			font-size: 15px;
			outline: none;
			box-sizing: border-box;
			line-height: 1.4;
			transition: border-color 0.2s, box-shadow 0.2s;

			&::placeholder {
				color: #94a3b8; // placeholder-slate-400
			}

			&:focus {
				border-color: #3b82f6;
				box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
			}
		}

		// 清除图标位置：避开右侧搜索按钮
		/deep/ .el-input__suffix {
			right: 108px;
			color: #cbd5e1;
		}

		/deep/ .el-input__icon {
			line-height: 58px;
		}
	}

	// 搜索按鈕 - 匹配 lz_project absolute right-2 top-1/2 -translate-y-1/2 bg-gradient-to-r from-blue-500 to-indigo-500 px-6 py-2 rounded-xl
	.hero-search-btn {
		position: absolute;
		right: 8px;
		top: 50%;
		transform: translateY(-50%);
		background: linear-gradient(to right, #3b82f6, #6366f1);
		color: #ffffff;
		border: none;
		padding: 10px 26px;
		border-radius: 12px; // rounded-xl
		font-size: 15px;
		font-weight: 600;
		cursor: pointer;
		transition: opacity 0.2s;
		white-space: nowrap;

		i {
			margin-right: 6px;
		}

		&:hover {
			opacity: 0.9;
		}
	}

	// ========== AI 提问输入区 ==========
	.hero-ai-box {
		position: relative;
		max-width: 672px;
		margin: 40px auto 0;
	}

	.hero-ai-input {
		width: 100%;
		padding: 16px 20px; // 右侧留出按钮空间
		border-radius: 16px;
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(4px);
		border: 1px solid rgba(255, 255, 255, 0.2);
		color: #ffffff;
		font-size: 15px;
		line-height: 1.6;
		outline: none;
		resize: vertical;
		box-sizing: border-box;
		transition: border-color 0.2s, box-shadow 0.2s;

		&::placeholder {
			color: #94a3b8;
		}

		&:focus {
			border-color: #3b82f6;
			box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
		}
	}

	.hero-ai-btn {
		position: absolute;
		right: 8px;
		bottom: 14px;
		background: linear-gradient(to right, #3b82f6, #6366f1);
		color: #ffffff;
		border: none;
		padding: 10px 22px;
		border-radius: 12px;
		font-size: 14px;
		font-weight: 600;
		cursor: pointer;
		transition: opacity 0.2s;
		white-space: nowrap;

		i {
			margin-right: 6px;
		}

		&:hover {
			opacity: 0.9;
		}
	}

	// CTA 按鈕组 - Tab 切换样式
	.hero-actions {
		display: flex;
		justify-content: center;
		gap: 16px;
		flex-wrap: wrap;
	}

	// 主按鈕 - 默认与 hero-btn-secondary 一致，tab-active 时切换为白底深色字
	.hero-btn-primary {
		background: rgba(255, 255, 255, 0.1) !important;
		backdrop-filter: blur(4px);
		color: #ffffff !important;
		border: 1px solid rgba(255, 255, 255, 0.2) !important;
		font-weight: 600;
		font-size: 17px;
		padding: 16px 22px !important;
		border-radius: 12px !important;
		transition: background 0.2s;
		cursor: pointer;

		i {
			margin-right: 6px;
		}

		&:hover {
			background: rgba(255, 255, 255, 0.2) !important;
		}
	}

	// 副按鈕 - 匹配 lz_project bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-xl
	.hero-btn-secondary {
		background: rgba(255, 255, 255, 0.1) !important;
		backdrop-filter: blur(4px);
		color: #ffffff !important;
		border: 1px solid rgba(255, 255, 255, 0.2) !important;
		font-weight: 600;
		font-size: 15px;
		padding: 12px 24px !important;
		border-radius: 12px !important;
		transition: background 0.2s;
		cursor: pointer;

		i {
			margin-right: 6px;
		}

		&:hover {
			background: rgba(255, 255, 255, 0.2) !important;
		}
	}

	.tab-active {
		box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.4) !important;
		transform: scale(1.05);
		background: #ffffff !important;
		color: #0f172a !important;
		border: none !important;

		&:hover {
			background: rgba(255, 255, 255, 0.9) !important;
		}
	}

	// 波浪装饰
	.hero-wave {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 80px;
		overflow: hidden;

		svg {
			width: 100%;
			height: 100%;
		}
	}

	.absolute {
		position: absolute;
		width: 100%;
		bottom: -7px;
	}

	// ========== 响应式 - 匹配 lz_project 断点 ==========
	@media screen and (max-width: 767px) {
		.hero-container {
			padding: 64px 16px 40px;
		}

		.hero-title {
			font-size: 36px; // text-4xl
		}

		.hero-desc {
			font-size: 16px;
		}

		.hero-badge {
			font-size: 12px;
			padding: 6px 14px;
		}

		.hero-search-input {
			/deep/ .el-input__inner {
				padding: 14px 104px 14px 44px;
				font-size: 14px;
			}
			/deep/ .el-input__suffix {
				right: 92px;
			}
		}

		.hero-btn-primary,
		.hero-btn-secondary {
			font-size: 14px;
			padding: 10px 20px !important;
		}

		.hero-ai-input {
			font-size: 14px;
			padding: 14px 16px;
		}

		.hero-ai-btn {
			font-size: 13px;
			padding: 8px 16px;
		}
	}

	// lg: py-28 = 112px
	@media screen and (min-width: 1024px) {
		.hero-container {
			padding: 112px 32px 118px;
		}
	}

	@media screen and (min-width: 768px) and (max-width: 1023px) {
		.hero-container {
			padding: 80px 24px 40px;
		}

		.hero-title {
			font-size: 48px;
		}
	}

	@media screen and (min-width: 1924px) {
		.hero-container {
			padding: 112px 32px 158px;
		}
	}
</style>

<!-- 非 scoped：el-autocomplete 的 popper 面板挂在 body 上，需全局覆盖 -->
<style lang="less">
	.hero-search-popper.el-autocomplete-suggestion {
		border-radius: 12px;
		border: 1px solid #e2e8f0;
		box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);
		margin-top: 8px !important;
		overflow: hidden;

		.el-autocomplete-suggestion__wrap {
			max-height: 320px;
			padding: 4px 0;
		}

		li {
			padding: 0 !important;
			line-height: normal !important;
			height: auto;
			color: #334155;
			font-size: 14px;
			transition: background 0.15s ease;

			&:hover {
				background: #f1f5f9;
			}

			&.highlighted {
				background: #edf3fe;
			}
		}

		.hero-suggest-item {
			display: flex;
			align-items: center;
			padding: 8px 14px;
			cursor: pointer;
			gap: 8px;
		}

		.hero-suggest-code {
			font-size: 12px;
			color: #2563eb;
			font-weight: 600;
			white-space: nowrap;
			flex-shrink: 0;
			background: #eff6ff;
			padding: 2px 6px;
			border-radius: 4px;
		}

		.hero-suggest-name {
			font-size: 13px;
			color: #1e293b;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
</style>
